import React, { Component } from "react";
import Dashboard from "../../layouts/DashboardLayOut";
import AddNewRoutePoint from "../../components/NewRoutePoint/AddNewRoutePoint";
import { Typography } from "@mui/material";
export class index extends Component {
  render() {
    return (
      <Dashboard>
        <Typography variant="h5" component="h5" style={{color:'#083979'}}>Route Points</Typography>
        <AddNewRoutePoint />
      </Dashboard>
    );
  }
}

export default index;
